<template>
  <v-tabs v-model="tabs">
    <v-tab :key="1">{{labels.cedRiDet}}</v-tab>
    <v-tab-item :key="1">
      <v-card flat>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{labels.editCedRi}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field :label="labels.grpAcctStmt" v-model="interForm.grpAcctStmt" item-text="label" item-value="value" data-vv-name="grpAcctStmt" :data-vv-as="labels.grpAcctStmt" :error-messages="errors.collect('grpAcctStmt')" v-validate="'entry'" readonly></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field :label="labels.acctType" v-model="interForm.acctType" item-text="label" item-value="value" data-vv-name="acctType" :data-vv-as="labels.acctType" :error-messages="errors.collect('acctType')" readonly></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-autocomplete :items="acctTypeList" :label="labels.inwardsOutwards" v-model="interForm.riType" item-text="label" item-value="value" data-vv-name="inwardsOutwards" :data-vv-as="labels.inwardsOutwards" :error-messages="errors.collect('inwardsOutwards')" :disabled="checkCedRI"></v-autocomplete>
              </v-flex>
              <v-flex xs5>
                <v-autocomplete :items="acctnosuffixes" :label="labels.acctNoSfx" v-model="interForm.acctNoSfx" item-text="label" item-value="value" data-vv-name="acctNoSfx" :data-vv-as="labels.acctNoSfx" :error-messages="errors.collect('acctNoSfx')" v-validate="'entry'" :disabled="checkCedRI"></v-autocomplete>
              </v-flex>
              <v-flex xs4>
                <cal-picker :label="labels.effDate" v-model="interForm.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="startDateValidation" :disabled="checkCedRI"></cal-picker>
              </v-flex>
              <v-flex xs3>
                <v-select :items="cedTypeList" v-model="interForm.cedType" :label="labels.cedType" item-text="label" item-value="value" data-vv-name="cedType" :data-vv-as="labels.cedType" :error-messages="errors.collect('cedType')"></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.cedName" v-model="interForm.intermediaryName" :error-messages="errors.collect('intermediaryName')" v-validate="'entry|max:60'" data-vv-name="intermediaryName" :data-vv-as="labels.intermediaryName" readonly></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field :label="labels.abbrevName" v-model="interForm.abbrevName" :error-messages="errors.collect('abbrevName')" v-validate="'entry|max:25'" data-vv-name="abbrevName" :data-vv-as="labels.abbrevName" readonly></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-expansion-panel>
                  <v-expansion-panel-content class="grey lighten-5 elevation-2">
                    <template v-slot:header>
                      <div class="v-icon mdi mdi-elevation-decline theme--light d-flex">
                        <span class="headerTitle">{{labels.underwriting}}</span>
                      </div>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <v-text-field :label="labels.addr1UW" v-model="interForm.addr1UW" :error-messages="errors.collect('addr1UW')" v-validate="'entry|max:25'" data-vv-name="addr1UW" :data-vv-as="labels.addr1UW"></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field :label="labels.addr2UW" v-model="interForm.addr2UW" :error-messages="errors.collect('addr2UW')" v-validate="'entry|max:25'" data-vv-name="addr2UW" :data-vv-as="labels.addr2UW"></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field :label="labels.addr3UW" v-model="interForm.addr3UW" :error-messages="errors.collect('addr3UW')" v-validate="'entry|max:25'" data-vv-name="addr3UW" :data-vv-as="labels.addr3UW"></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field :label="labels.addr4UW" v-model="interForm.addr4UW" :error-messages="errors.collect('addr4UW')" v-validate="'entry|max:25'" data-vv-name="addr4UW" :data-vv-as="labels.addr4UW"></v-text-field>
                            </v-flex>
                            <!-- <v-flex xs4>
                              <v-autocomplete :label="labels.ctyUW" v-model="interForm.ctyUW" :items="ctyList" item-text="label" item-value="value" :error-messages="errors.collect('matchForm.ctyUW')" data-vv-name="matchForm.ctyUW" :data-vv-as="labels.ctyUW" v-validate="'entry|max:16'"></v-autocomplete>
                            </v-flex> -->
                            <v-flex xs4>
                              <v-text-field :label="labels.postCodeUW" v-model="interForm.postCodeUW" v-int-mask="{intScale: 8}" type="tel" :error-messages="errors.collect('postCodeUW')" v-validate="'numeric|max:8'" data-vv-name="postCodeUW" :data-vv-as="labels.postCodeUW" :loading="PostCodeUWLoading" @change="doAddressUW"></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-content class="grey lighten-5 elevation-2">
                    <template v-slot:header>
                      <div class="v-icon mdi mdi-elevation-decline theme--light d-flex">
                        <span class="headerTitle">{{labels.accounting}}</span>
                      </div>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <v-text-field :label="labels.addr1Acct" v-model="interForm.addr1Acct" :error-messages="errors.collect('addr1Acct')" v-validate="'entry|max:25'" data-vv-name="addr1Acct" :data-vv-as="labels.addr1Acct"></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field :label="labels.addr2Acct" v-model="interForm.addr2Acct" :error-messages="errors.collect('addr2Acct')" v-validate="'entry|max:25'" data-vv-name="addr2Acct" :data-vv-as="labels.addr2Acct"></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field :label="labels.addr3Acct" v-model="interForm.addr3Acct" :error-messages="errors.collect('addr3Acct')" v-validate="'entry|max:25'" data-vv-name="addr3Acct" :data-vv-as="labels.addr3Acct"></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field :label="labels.addr4Acct" v-model="interForm.addr4Acct" :error-messages="errors.collect('addr4Acct')" v-validate="'entry|max:25'" data-vv-name="addr4Acct" :data-vv-as="labels.addr4Acct"></v-text-field>
                            </v-flex>
                            <!-- <v-flex xs4>
                              <v-autocomplete :label="labels.ctyAcct" v-model="interForm.ctyAcct" :items="ctyList" item-text="label" item-value="value" :error-messages="errors.collect('matchForm.ctyAcct')" data-vv-name="matchForm.ctyAcct" :data-vv-as="labels.ctyAcct" v-validate="'entry|max:16'"></v-autocomplete>
                            </v-flex> -->
                            <v-flex xs4>
                              <v-text-field :label="labels.postCodeAcct" v-model="interForm.postCodeAcct" v-int-mask="{intScale: 8}" type="tel" :error-messages="errors.collect('postCodeAcct')" v-validate="'numeric|max:8'" data-vv-name="postCodeAcct" :data-vv-as="labels.postCodeAcct" :loading="PostCodeAcctLoading" @change="doAddressAcct"></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-flex lg6 md12 xs12>
          <v-card-actions >
            <v-btn class="white--text error" @click.prevent="doBack">
              Cancel
              <v-icon right>mdi-exit-to-app</v-icon>
            </v-btn>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
              Save
              <v-icon right>{{newCedRi? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
            </v-btn>
          </v-card-actions>
        </v-flex>
        <confirm v-model="promptAddNew" @cancel="doCancelAddNew" @ok="doAddNew">
          Add some more
        </confirm>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { interTitle, interCommType, interRegAgt, interStmtType } from '@/const/underwriting'
import { mapGetters, mapActions } from 'vuex'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { cedType, acctType } from '@/const/params'

export default {
  data() {
    return {
      tabs: 0,
      toogleArray: [true, false],
      labels: {
        cedRiDet: 'Cedant / Reinsurer Details',
        editCedRi: 'Edit Cedant / Reinsurer',
        grpAcctStmt: 'Group Account For Statement',
        acctType: 'Account Type',
        inwardsOutwards: 'Inwards / Outwards',
        cedRiRef: 'Cedant / Reinsurer Reference',
        acctNoSfx: 'Account No. Suffix',
        effDate: 'Effective Date',
        cedType: 'Insurer or Broker',
        cedName: 'Full Name',
        abbrevName: 'Abbreviated Name*',
        underwriting: 'UnderWriting',
        addr1UW: 'Underwriting Address',
        addr2UW: 'Underwriting Address 2',
        addr3UW: 'Underwriting Address 3',
        addr4UW: 'Underwriting Address 4',
        ctyUW: 'Country',
        postCodeUW: 'Postal Code',
        accounting: 'Accounting',
        addr1Acct: 'Accounting Address',
        addr2Acct: 'Accounting Address 2',
        addr3Acct: 'Accounting Address 3',
        addr4Acct: 'Accounting Address 4',
        ctyAcct: 'Country',
        postCodeAcct: 'Postal Code',
        stmtType: 'Statement Type',
        grpRefStmt: 'Group Intermediary No. for Statement',
        grpRefAge: 'Group Intermediary No. for Ageing',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      interForm: {
        acctType: undefined,
        riType: 'O',
        riRef: undefined,
        acctNoSfx: undefined,
        effDate: new Date(),
        cedType: 'I',
        cedArea: undefined,
        cedName: undefined,
        abbrevName: undefined,
        addr1UW: undefined,
        addr2UW: undefined,
        addr3UW: undefined,
        addr4UW: undefined,
        ctyUW: undefined,
        postCodeUW: undefined,
        addr1Acct: undefined,
        addr2Acct: undefined,
        addr3Acct: undefined,
        addr4Acct: undefined,
        ctyAcct: undefined,
        postCodeAcct: undefined,
        inter: undefined,
        interGroupCode: undefined,
        interGroupName: undefined,
        titleName: undefined,
        intermediaryName: undefined,
        interType: undefined
      },
      interGroupList: [],
      ctyList: [],
      interTypeList: [],
      interHomeBranchList: [],
      interCurrList: [],
      interExecICList: [],
      interList: [],
      interByInterGrpList: [],
      menu: [],
      acctnosuffixes: [],
      newCedRi: false,
      newIntermediary: false,
      submitting: false,
      PostCodeUWLoading: false,
      PostCodeAcctLoading: false,
      InterPostalCodeLoading: false,
      checkCedRI: false,
      promptAddNew: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    startDateValidation() {
      return 'required'
    },
    endDateValidation() {
      if (this.interForm.dateClosed !== undefined && this.interForm.dateClosed !== '') {
        return 'entry|start_enddate:' + this.interForm.dateOpened
      } else {
        return ''
      }
    },
    intermediaryForm() {
      return this.$store.state.adminInter.intermediary
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function(key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    cedTypeList() {
      let result = []
      Object.keys(cedType).forEach(function(key) {
        const status = cedType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    interTitleList() {
      let result = []
      Object.keys(interTitle).forEach(function(key) {
        const status = interTitle[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    interCommTypeList() {
      let result = []
      Object.keys(interCommType).forEach(function(key) {
        const status = interCommType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    interRegAgtList() {
      let result = []
      Object.keys(interRegAgt).forEach(function(key) {
        const status = interRegAgt[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    interStmtTypeList() {
      let result = []
      Object.keys(interStmtType).forEach(function(key) {
        const status = interStmtType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    ...mapActions([
      'interMenuInit'
    ]),
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('acctnosuffixes')
      // Default value from vuex store 1st
      this.interForm.acctType = this.intermediaryForm.interGroupName
      this.interForm.riRef = this.intermediaryForm.inter
      this.interForm.inter = this.intermediaryForm.inter
      this.interForm.cedArea = this.intermediaryForm.cty
      this.interForm.interGroupCode = this.intermediaryForm.interGroupCode
      this.interForm.interGroupName = this.intermediaryForm.interGroupName
      this.interForm.interType = this.intermediaryForm.interType
      this.interForm.titleName = this.intermediaryForm.titleName
      this.interForm.intermediaryName = this.intermediaryForm.intermediaryName
      this.interForm.cedName = this.intermediaryForm.intermediaryName
      this.interForm.abbrevName = this.intermediaryForm.abbrevName
      this.fetchCedRI()
    },
    async getInterGroupList() {
      const apiURI = this.$store.state.adminInter.menu.interGroup
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.interGroupList = data.data.interGroupList
        }
      } catch (err) {
        throw err
      }
    },
    async getCtyList() {
      const apiURI = this.$store.state.adminInter.menu.countryList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.ctyList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterTypeList() {
      const apiURI = this.$store.state.adminInter.menu.interTypeList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          if (this.newIntermediary) {
            this.interForm.interType = result.data.data.interType
          }
          this.interTypeList = result.data.data.interTypeList
        }
      } catch (err) {
        throw err
      }
    },
    async fetchCedRI() {
      const apiUrl = this.$store.state.adminInter.menu.getCedRI
      if (apiUrl) {
        try {
          const expand = {
            riRef: this.interForm.inter,
            riType: this.interForm.interGroupCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.checkCedRI = true
            this.interForm.riType = data.riType
            this.interForm.effDate = data.effDate
            this.interForm.acctNoSfx = data.acctNoSfx
            this.interForm.cedType = data.cedType
            this.interForm.addr1UW = data.addr1UW
            this.interForm.addr2UW = data.addr2UW
            this.interForm.addr3UW = data.addr3UW
            this.interForm.addr4UW = data.addr4UW
            this.interForm.postCodeUW = data.postCodeUW
            this.interForm.addr1Acct = data.addr1Acct
            this.interForm.addr2Acct = data.addr2Acct
            this.interForm.addr3Acct = data.addr3Acct
            this.interForm.addr4Acct = data.addr4Acct
            this.interForm.postCodeAcct = data.postCodeAcct
          } else {
            this.checkCedRI = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doAddressUW() {
      const apiUrl = this.$store.state.adminInter.menu.address
      if (apiUrl) {
        try {
          this.PostCodeUWLoading = true
          const expand = {
            postCode: this.interForm.postCodeUW
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.interForm.addr1UW = data.add1
            this.interForm.addr2UW = data.add2
            this.interForm.addr4UW = data.add4
          }
          this.PostCodeUWLoading = false
        } catch (err) {
          this.PostCodeUWLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doAddressAcct() {
      const apiUrl = this.$store.state.adminInter.menu.address
      if (apiUrl) {
        try {
          this.PostCodeAcctLoading = true
          const expand = {
            postCode: this.interForm.postCodeAcct
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.interForm.addr1Acct = data.add1
            this.interForm.addr2Acct = data.add2
            this.interForm.addr4Acct = data.add4
          }
          this.PostCodeAcctLoading = false
        } catch (err) {
          this.PostCodeAcctLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doInterAddress() {
      const apiUrl = this.$store.state.adminInter.menu.address
      if (apiUrl) {
        try {
          this.InterPostalCodeLoading = true
          const expand = {
            postCode: this.interForm.postalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.interForm.addr1 = data.add1
            this.interForm.addr2 = data.add2
            this.interForm.addr4 = data.add4
          }
          this.InterPostalCodeLoading = false
        } catch (err) {
          this.InterPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getInterHomeBranchList() {
      const apiURI = this.$store.state.adminInter.menu.homeBranchList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interHomeBranchList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterCurrList() {
      const apiURI = this.$store.state.adminInter.menu.currencyList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interCurrList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterExecICList() {
      const apiURI = this.$store.state.adminInter.menu.execICList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interExecICList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterByInterGrpList() {
      const apiURI = this.$store.state.adminInter.menu.interByInterGrpList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interByInterGrpList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterList() {
      const apiURI = this.$store.state.adminInter.menu.interList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getDefStmtType() {
      const apiURI = this.$store.state.adminInter.menu.getDefStmtType
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.interForm.stmtType = data.data.defStmtType
        }
      } catch (err) {
        throw err
      }
    },
    doBack() {
      this.$router.push({ name: 'intermediaries' })
    },
    doSave() {
      this.toogleArray = [true, true]
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // this.fetchCedRI().then(result => {
          if (this.checkCedRI) {
            this.doUpdate()
          } else {
            this.doCreate()
          }
          // })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.$store.state.adminInter.menu.cedRIUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.interForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            // this.$store.dispatch('interMenuInit', this.interForm.inter)
            // Redirect back to listing
            // this.$router.push({ name: 'reviewProfile' })
          }
          this.submitting = false
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCreate() {
      if (this.interForm.riRef === undefined || this.interForm.riType === undefined || this.interForm.effDate === undefined) {
        this.promptFieldCheck()
      } else {
        const apiURI = this.$store.state.adminInter.menu.cedRICreate
        if (apiURI) {
          this.submitting = true
          try {
            const result = await this.$http.post(apiURI, this.interForm)
            const { data } = result
            if (data) {
              // Show message via notify
              this.notify(data)
              if (this.interForm.inter == null) {
                this.interForm.inter = data.inter
              }

              // this.promptAddNew = true
            }
            this.submitting = false
            this.doInit()
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
              this.notify(data)
            }
            this.submitting = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async doCancelAddNew() {
      this.$router.push({ name: 'intermediaries' })
    },
    async doAddNew() {
      this.$router.push({ name: 'reviewProfile', params: { inter: 'new', interGroupCode: 'new' } })
      this.newIntermediary = true
      this.doRefresh()
    },
    doRefresh() {
      this.toogleArray = [true, false]
      this.interForm.interNoAe = true
      this.interForm.inter = null
      this.interForm.interGroupCode = '10'
      this.interForm.interGroupName = null
      this.interForm.titleName = null
      this.interForm.intermediaryName = null
      this.interForm.interType = null
      this.interForm.abbrevName = null
      this.interForm.contact = null
      this.interForm.telNo1 = null
      this.interForm.telNo2 = null
      this.interForm.telNo3 = null
      this.interForm.telNo4 = null
      this.interForm.telNo5 = null
      this.interForm.addr1 = null
      this.interForm.addr2 = null
      this.interForm.addr3 = null
      this.interForm.addr4 = null
      this.interForm.postalCode = null
      this.interForm.addrState = null
      this.interForm.addrCtry = null
      this.interForm.email = null
      this.interForm.web = null
      this.interForm.dateOpened = new Date()
      this.interForm.dateClosed = null
      this.interForm.commType = 'O'
      this.interForm.branch = null
      this.interForm.cty = null
      this.interForm.regAgt = null
      this.interForm.gstRegNo = null
      this.interForm.gstRegDate = null
      this.interForm.crPer = 0
      this.interForm.crLim = 0
      this.interForm.crLimCurr = null
      this.interForm.perDebtTran = false
      this.interForm.blackList = false
      this.interForm.inactive = false
      this.interForm.suspended = false
      this.interForm.execIC = null
      this.interForm.schemeMand = false
      this.interForm.stmtType = null
      this.interForm.grpRefStmt = null
      this.interForm.grpRefAge = null
      this.interForm.createdBy = null
      this.interForm.createdDate = null
      this.interForm.modifiedBy = null
      this.interForm.modifiedDate = null
      this.getDefStmtType()
      this.getInterTypeList()
    },
    doInterNoAe() {
      if (this.interForm.interNoAe) {
        this.interForm.inter = null
        this.interForm.interNoAe = true
        this.errors.remove('inter')
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    }
  },
  created() {
    Promise.all([this.getInterGroupList(), this.getCtyList(), this.getInterTypeList(), this.getInterHomeBranchList(), this.getInterCurrList(), this.getInterExecICList(), this.getInterList(), this.getInterByInterGrpList()])
    if (this.inter === 'new') {
      this.getDefStmtType()
      this.newIntermediary = true
    } else {
      this.doInit()
    }
  },
  props: ['inter', 'interGroupCode', 'interNoAe'],
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ]
}
</script>

<style lang="scss">

</style>
